import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useGetUser from '../../hooks/useGetUser';
import CheckboxTree from 'react-checkbox-tree';
import { Button, Icon, Loading, notification, Tile } from '@cv/eds-react';
import useGetConfigRegions from '../../hooks/useGetConfigRegions';
import usePostUser from '../../hooks/usePostUser';
import classes from './EditUser.module.css';
import { ROUTEURLS } from '../../routes';

const EditUser = () => {
  const { user_login } = useParams();
  const {
    data: userDetails,
    isError: isErrorUserDetails,
    isLoading: isLoadingUserDetails,
    error: errorUserDetails,
  } = useGetUser(user_login);
  const {
    data: allRegions,
    isLoading: isLoadingAllRegions,
    isError: isErrorAllRegions,
    error: errorAllRegions
  } = useGetConfigRegions();

  const [valuesChecked, setValuesChecked] = useState([]);
  const [valuesExpanded, setValuesExpanded] = useState([]);
  const [nodes, setNodes] = useState([]);

  const {
    mutate,
    isLoading: isLoadingPostUser,
    isError: isErrorPostUser,
    error: errorPostUser
  } = usePostUser();

  useEffect(() => {
    if (
      userDetails &&
      userDetails?.data.customer &&
      Object.keys(userDetails?.data.customer).length > 0
    ) {
      let checkedList = [];
      Object.keys(userDetails?.data.customer).map((c) => {
        if (userDetails.data.customer[c].length > 0) {
          // Add customer in selected values 
          const modifiedArray = userDetails.data.customer[c].map(item => item + c.toLowerCase());
          checkedList = [...checkedList, ...modifiedArray];
        }
      });
      setValuesChecked(checkedList);
    }
  }, [userDetails]);
  useEffect(() => {
    if (allRegions?.data) {
      const nodes = allRegions?.data.map((c) => {
        const n = {
          value: c.id,
          label: c.name,
          children: c.regions.map((r) => ({
            // Add customer with value
            value: r+c.id,
            label: r
          }))
        };
        return n;
      });
      if (nodes.length) {
        setValuesExpanded([nodes[0]?.value]);
        setNodes(nodes);
      }
    }

  }, [allRegions]);

  const icons = {
    check: <Icon type="select" fontSize={18} className={classes.iconClass} />,
    uncheck: <Icon type="square" fontSize={18} className={classes.iconClass} />,
    halfCheck: <Icon type="minus" fontSize={18} className={classes.iconClass} />,
    expandClose: (
      <Icon type="chevron-right" fontSize={18} className={classes.iconClass} />
    ),
    expandOpen: <Icon type="chevron-down" fontSize={18} className={classes.iconClass} />
  };

  const handleSaveRegionsData = async () => {
    const body = userDetails?.data;
    const copyNodes = JSON.parse(JSON.stringify(nodes));
    const nodesWithSelection = copyNodes.filter((n) => {
      n.children = n.children.filter((r) => {
        if (valuesChecked.includes(r.value)) {
          return r;
        }
      });
      if (n.children.length > 0) {
        return n;
      }
    });
    const customer = {};

    // Remove customer from value
    const modifiedResponse = nodesWithSelection.map(item => ({
      ...item,
      children: item.children.map(child => ({
        ...child,
        value: child.value.replace(item.value, '')
      }))
    }));

    modifiedResponse.forEach((n) => {
      customer[n.value] = n.children.map((r) => r.value);
    });
    body.customer = customer;

    const response = await mutate(body);
    if (response) {
      notification.notice({
        title: (
          <>
            <Icon type="check" /> Updated Successfully.
          </>
        )
      });
    }
  };

  if (isLoadingAllRegions || isLoadingPostUser || isLoadingUserDetails) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        {/* <Loading size="medium" /> */}
      </div>
    );
  } else if (isErrorAllRegions || isErrorUserDetails) {
    if (errorUserDetails) {
      return (
        <div className="d-flex justify-content-center align-items-center">
          <p>
            {errorUserDetails?.message
              ? errorUserDetails?.message
              : 'Something went wrong please try again.'}
          </p>
        </div>
      );
    } else {
      return (
        <div className="d-flex justify-content-center align-items-center">
          <p>
            {errorAllRegions?.message
              ? errorAllRegions?.message
              : 'Something went wrong please try again.'}
          </p>
        </div>
      );
    }
  } else {
    return (
      <div className="row">
        <div className="column sm-12">
          {nodes?.length > 0 && (
            <Tile
              fullScreen
              className="overflow-auto"
              title={`Update ${
                userDetails?.data.name ? userDetails?.data.name : 'User'
              } Regions Data`}
            >
              <div>
                <div style={{ marginBottom: '20px' }}>
                  <CheckboxTree
                    icons={icons}
                    nodes={nodes}
                    checked={valuesChecked}
                    expanded={valuesExpanded}
                    onCheck={(checked) => {
                      setValuesChecked(checked);
                    }}
                    onExpand={(expanded) => {
                      setValuesExpanded(expanded);
                    }}
                    showNodeIcon={false}
                  />
                </div>
                <Button onClick={handleSaveRegionsData}>Save</Button>
                <Button href={`/#${ROUTEURLS.adminPanel}`}>Close</Button>
              </div>
            </Tile>
          )}
        </div>
      </div>
    );
  }
};

export default EditUser;
